import { defineStore } from 'pinia';
import { publicService } from '@/api/';
// import { Message } from '@arco-design/web-vue';
// import i18n from '@/locales/index';
export const useFilterListStore = defineStore('filterList', {
  state: () => ({
    // 筛选项列表
    conditionsList: [],
    conditionsListLoading: true,
    // 自定义排序
    fieldsSort: [],
    // 默认排序
    fieldsSortDefault: [],
    // 排序ID
    sortId: { entity: '', sId: '' },
    routerBusinessId: '', //路由businessId(通常通过消息卡片点击打开详情)
    isFirst: true
  }),
  actions: {
    getFieldsSort() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          try {
            const data = (this.fieldsSort = []);
            resolve(data);
          } catch (error) {
            reject(error);
          }
        }, 500);
      });
    },

    setFieldsSort(v) {
      if (Array.isArray(v)) {
        if (v?.length == 0) {
          this.fieldsSort = [];
        } else {
          v.forEach((item) => {
            const index = this.fieldsSort.findIndex((ele) => ele.fieldKey === item.fieldKey);
            if (index !== -1) {
              this.fieldsSort[index] = { ...this.fieldsSort[index], ...item };
            } else {
              this.fieldsSort.push(item);
            }
          });
        }
      } else {
        const index = this.fieldsSort.findIndex((ele) => ele.fieldKey === v.fieldKey);
        if (index !== -1) {
          this.fieldsSort[index] = { ...this.fieldsSort[index], ...v };
        } else {
          this.fieldsSort.push(v);
        }
      }
      return this.fieldsSort;
    },
    submitSortFn(v) {
      if (Array.isArray(v)) {
        this.fieldsSort = v;
      }
    },
    setFieldsSortDefault(v) {
      if (Array.isArray(v)) {
        if (v?.length == 0) {
          this.fieldsSortDefault = [];
        } else {
          v.forEach((item) => {
            const index = this.fieldsSortDefault.findIndex((ele) => ele.fieldKey === item.fieldKey);
            if (index !== -1) {
              this.fieldsSortDefault[index] = { ...this.fieldsSortDefault[index], ...item };
            } else {
              this.fieldsSortDefault.push(item);
            }
          });
        }
      } else {
        const index = this.fieldsSortDefault.findIndex((ele) => ele.fieldKey === v.fieldKey);
        if (index !== -1) {
          this.fieldsSortDefault[index] = { ...this.fieldsSortDefault[index], ...v };
        } else {
          this.fieldsSortDefault.push(v);
        }
      }
      return this.fieldsSortDefault;
    },
    setSortId(entity, sId) {
      this.sortId.entity = entity;
      this.sortId.sId = sId;
    },
    setIsFirst(v) {
      this.isFirst = v;
    },
    // 查询筛选条件
    getConditionsList(params) {
      this.conditionsList = [];

      return new Promise((resolve, reject) => {
        publicService
          .getConditionParamsList(params)
          .then((res) => {
            if (res?.error) {
              // Message.error(res.error?.msg);
              return;
            }
            this.conditionsList = res?.result || [];
            this.conditionsListLoading = false;
            console.log('获取筛选项', res?.result, this.conditionsList);
            resolve(res);
          })
          .catch((err) => {
            this.conditionsListLoading = false;
            // Message.error(err.message || err.statusText || i18n.global.t('获取数据失败'));
            reject(err);
          });
      });
    },
    // 保存当前用户的筛选条件
    setConditionsList(params) {
      this.conditionsList = params?.conditions || [];
      console.log(params, 'storeSet', this.state, this.conditionsList);
      return new Promise((resolve, reject) => {
        publicService
          .setConditionParamsList(params)
          .then((res) => {
            console.log('保存筛选条件', res);
            if (res.error) {
              // Message.error(res.error?.msg);
              return;
            }
            resolve(res);
          })
          .catch((err) => {
            // Message.error(err?.msg || i18n.global.t('操作失败'));
            reject(err);
          });
      });
    },
    //列表保存路由上的id参数
    updateRouterBusinessId(id) {
      this.routerBusinessId = id;
    }
  }
});
export default useFilterListStore;
